import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Router, ActivatedRoute } from '@angular/router';
import { CustomHttp } from '../../common/customHttp.service';
import { ApiUrl } from '../../common/apiUrls';
import { FormGroup, FormBuilder } from '@angular/forms';
import { MainAppComponent } from '../../layout/layout.component';
import { PagerService } from '../../common/pagerService';
import 'rxjs/add/operator/map';
import { ConsolidatedSearchFields } from '../../common/viewModels/Reports/KpiModel';
import { CustomerModel } from '../../common/viewModels/Admin/CustomerModel';
import { PageEvent } from '@angular/material';
import { FormatService } from '../../common/formatService';
import { RequestOptions, ResponseContentType } from '@angular/http';
import { HttpHeaders } from '@angular/common/http/src/headers';
import { JobCardsListModel } from '../../common/viewModels/Analysis/SampleModel';
@Component({
    selector: 'ConsolidatedReport',
    templateUrl: './ConsolidatedReport.component.html',
    styleUrls: ['./ConsolidatedReport.component.scss']
})
export class ConsolidatedReportComponent implements OnInit {
    searchForm: FormGroup;
    searchFields: ConsolidatedSearchFields = new ConsolidatedSearchFields();
    customers: CustomerModel[];
    customersTemp: CustomerModel[];
    id: number;
    isNoRecords: boolean = true;
    pager: any = {};
    pagedItems: any[];
    length: number = 0;
    pageSize: number = 10;
    pageIndex: number = 0;
    pageSizeOptions = [10, 25];
    pageEvent: PageEvent;
    name: any;
    areas: any[];
    oilgrades: any[];
    lstSampleTypes: any[];
    lstJobCards: JobCardsListModel[];
    labs: any;

    constructor(public _router: Router, private _formBuilder: FormBuilder,
        private _http: CustomHttp,
        private _appUrl: ApiUrl, private _route: ActivatedRoute, private _pagerService: PagerService,
        private _mApp: MainAppComponent, private _toastrService: ToastrService, private _formatService: FormatService) {
    }

    ngOnInit() {
        var currentUser = JSON.parse(localStorage.getItem('currentUser'));
        let curUserDetails = this._mApp.getCurrentUserData(currentUser.token);
        this.pageSize = localStorage.getItem('PageSize') ? parseInt(localStorage.getItem('PageSize')) : 10;
        this.pager.pageSize = this.pageSize;
        this.pager.pageIndex = 0;
        this.pager.pageSizeOptions = this._pagerService.pageSizeOptions;
        this.createSearchForm();
        if (curUserDetails && curUserDetails.LabIds && curUserDetails.UserTypeId == 2) {
            this.searchForm.controls['LabIds'].setValue(JSON.parse(curUserDetails.LabIds));
        }
        if (curUserDetails && curUserDetails.DefaultCompanyId && curUserDetails.UserTypeId == 3) {
            this.searchForm.controls['CustomerId'].setValue([parseInt(curUserDetails.DefaultCompanyId)]);
            this.BindJobCard(this.searchForm.controls['CustomerId'].value);
        }
        this.BindSearchFileds();
        this.setPage(this.pager);
        // this.GetAreas();
        // this.GetOilGrades();
        this.GetLabs();
        this.GetCustomers();
        this.GetSampleTypes();
        this.BindStaticSearchData();
    }

    createSearchForm() {
        this.searchForm = this._formBuilder.group({
            // AreaId: [0],
            // Equipment: [''],
            // OilGradeId: [0],
            SampleNo: [''],
            SpId: [''],
            CustomerId: [''],
            LabIds: [''],
            JobCardNumber: [''],
            ReceivedFrom: [null],
            ReceivedTo: [null],
            SampleStatusTypeId: [''],
            SampleTypeId: ['']
        });
    }

    setPage(page: any) {
        this.pager.pageSize = page.pageSize;
        this.pager.pageIndex = page.pageIndex;
        this.GetConsolidatedList(this.pager);
    }

    BindStaticSearchData() {
        this.searchFields.PageNo = 0;
        this.searchFields.PageSize = this._pagerService.globalPageSize;
    }

    GetAreas() {
        this._http.get(this._appUrl.GetAreaMinInfoList)
            .subscribe(
                data => {
                    this.areas = data.json().Result;
                },
                error => {
                    this._toastrService.error(error.json().Result, '')
                }
            )
    }

    GetLabs() {
        this._http.get(this._appUrl.GetLabsMinInfoList)
            .subscribe(
                data => {
                    if(this._mApp.userTypeId == 2) {
                        let lstLabs = data.json().Result;
                        if (this._mApp.currentUserLabIds && lstLabs)
                        lstLabs = lstLabs.filter(m => this._mApp.currentUserLabIds.includes(m.LabId));
                        this.labs = lstLabs;
                    }
                    else {
                        this.labs = data.json().Result;
                    }
                },
                error => {
                    this._toastrService.error(error.json())
                }
            )
    }

    GetOilGrades() {
        this._http.get(this._appUrl.GetOilGradesForDDL)
            .subscribe(
                data => {
                    this.oilgrades = data.json().Result;
                },
                error => {
                    this._toastrService.error(error.json().Result, '')
                }
            )
    }

    GetCustomers() {
        this._http.get(this._appUrl.GetCustomersMinInfoList)
            .subscribe(
                data => {
                    this.customers = data.json().Result;
                    this.customersTemp = data.json().Result;
                },
                error => {
                    this._toastrService.error(error.json().Result, '')
                }
            )
    }

    GetSampleTypes() {
        this._http.get(this._appUrl.GetMinInfoSampleTypes)
            .subscribe(
                data => {
                    if (data.json().Result != null)
                        this.lstSampleTypes = data.json().Result;
                },
                error => {
                    this._toastrService.error(error.json().Result);
                }
            )
    }
    BindJobCard(val: any[]) {

        this._http.post(this._appUrl.GetJobCardsByCustomer, val)
            .subscribe(
                data => {
                    if (data.json().Result != null)
                        this.lstJobCards = data.json().Result;
                },
                error => {
                    this._toastrService.error(error.json().Result);
                }
            )
    }
    GetConsolidatedList(page: any) {
        this._mApp.ShowLoader();
        this.searchFields.PageNo = page.pageIndex;
        this.searchFields.PageSize = page.pageSize;
        this._mApp.ShowLoader();
        this._http.post(this._appUrl.ConsolidatedList, this.searchFields)
            .subscribe(
                res => {
                    this._mApp.HideLoader();
                    var data = res.json();
                    this.length = data.PageResult.TotalRecords;
                    this.pageSize = data.PageResult.PageSize;
                    this.pageIndex = data.PageResult.PageNo;
                    this.pagedItems = data.Result;
                    this.isNoRecords = !(data.Result.length > 0);
                    this._mApp.HideLoader();
                },
                error => {
                    this._mApp.HideLoader();
                    this._toastrService.error(error.json().Result, '');
                }
            );
    }

    onSubmit() {
   const customerVal = this.searchForm.controls['CustomerId'].value;
   const jobCardVal = this.searchForm.controls['JobCardNumber'].value;

    if ((!customerVal || customerVal.length === 0) &&
        (!jobCardVal || jobCardVal.length === 0)) {

        this._toastrService.error('Please select Customer and Job Card', '');
        return;
    }

    if (!customerVal || customerVal.length === 0) {
        this._toastrService.error('Please select Customer', '');
        return;
    }

    if (!jobCardVal || jobCardVal.length === 0) {
        this._toastrService.error('Please select Job Card', '');
        return;
    }
        this.pager.pageIndex = 0;
        this.BindSearchFileds();
        this.setPage(this.pager);
    }

    OnReset() {
        this.searchForm.reset();
        this.pager.pageSize = this._mApp.pageSize;
        this.pager.pageIndex = 0;
        this.searchFields.CustomerId = 0;
        this.searchFields.SampleNo = 0;
        this.searchFields.SpId = 0;
        this.searchFields.LabIds = [];
        this.searchFields.JobCardNumber = '';
        this.searchFields.ReceivedDateFrom = '';
        this.searchFields.ReceivedDateTo = '';
        this.searchFields.SampleStatusTypeId = 0;
        this.searchFields.SampleTypeId = 0;
        // this.GetAreas();
        // this.GetOilGrades();
        this.lstJobCards = null;
        this.GetCustomers();
        this.searchFields.IsList = false;
        //  this.pagedItems = [];
        //  this.isNoRecords = true;
            var currentUser = JSON.parse(localStorage.getItem('currentUser'));
            let curUserDetails = this._mApp.getCurrentUserData(currentUser.token);
        if (this._mApp.userTypeId == 2) {
            this.searchForm.controls['LabIds'].setValue(JSON.parse(curUserDetails.LabIds));
        }
        if (curUserDetails && curUserDetails.DefaultCompanyId && curUserDetails.UserTypeId == 3) {
            this.searchForm.controls['CustomerId'].setValue([parseInt(curUserDetails.DefaultCompanyId)]);
            this.BindJobCard(this.searchForm.controls['CustomerId'].value);
        }
        this.BindSearchFileds();
        this.setPage(this.pager);
    }

    BindSearchFileds() {
        let searchDto = this.searchForm.value;
        if (searchDto.CustomerId != "" && searchDto.CustomerId != null && searchDto.CustomerId != undefined)
            this.searchFields.CustomerId = searchDto.CustomerId;
        else
            this.searchFields.CustomerId = null;
        this.searchFields.SampleNo = searchDto.SampleNo;
        this.searchFields.SpId = searchDto.SpId;
        this.searchFields.LabIds = searchDto.LabIds;
        if (searchDto.JobCardNumber != "" && searchDto.JobCardNumber != null && searchDto.JobCardNumber != undefined)
            this.searchFields.JobCardNumber = searchDto.JobCardNumber;
        else
            this.searchFields.JobCardNumber = null;

        this.searchFields.ReceivedDateFrom = this._formatService.formatDate(searchDto.ReceivedFrom);
        this.searchFields.ReceivedDateTo = this._formatService.formatDate(searchDto.ReceivedTo);
        this.searchFields.SampleStatusTypeId = searchDto.SampleStatusTypeId;

        if (searchDto.SampleTypeId != "" && searchDto.SampleTypeId != null && searchDto.SampleTypeId != undefined) {
            this.searchFields.SampleTypeId = searchDto.SampleTypeId;
        }
        else
            this.searchFields.SampleTypeId = null;

        if (this.searchFields.CustomerId != null || this.searchFields.JobCardNumber != null || this.searchFields.ReceivedDateFrom != null || this.searchFields.ReceivedDateTo || this.searchFields.SampleTypeId != null) {
            this.searchFields.IsList = true;
        }
    }  
   
     ExportSampStatExcel() {
       const customerVal = this.searchForm.controls['CustomerId'].value;
      const jobCardVal = this.searchForm.controls['JobCardNumber'].value;

      if ((!customerVal || customerVal.length === 0) &&
          (!jobCardVal || jobCardVal.length === 0)) {

          this._toastrService.error('Please select Customer and Job Card', '');
          return;
      }

      if (!customerVal || customerVal.length === 0) {
          this._toastrService.error('Please select Customer', '');
          return;
      }

      if (!jobCardVal || jobCardVal.length === 0) {
          this._toastrService.error('Please select Job Card', '');
          return;
      }

        this.BindSearchFileds();
        this._mApp.ShowLoader();
        this.searchFields.IsForExcel = true;
        this._http.post(this._appUrl.ExportConsolidatedExcel, this.searchFields)
            .subscribe(
                res => {
                    window.open(res.json().Result, '_blank');
                    this.searchFields.IsForExcel = false;
                    this._mApp.HideLoader();
                },
                error => {
                    this._mApp.HideLoader();
                    this._toastrService.error(error.json().Result, '');
                }
            );
    }

    OilAnalysisExportExcel() {
        const receivedFrom = this.searchForm.controls['ReceivedFrom'].value;
        const receivedTo = this.searchForm.controls['ReceivedTo'].value;
       
        if(receivedFrom == null || receivedTo == null || receivedFrom == '' || receivedTo == '' || receivedFrom == undefined || receivedTo == undefined){
            this._toastrService.error('Please select Received From and Received To date', '');
            return;
        }
        if(receivedFrom != null && receivedTo != null && receivedFrom != '' && receivedTo != ''){
            if(receivedFrom > receivedTo){
                this._toastrService.error('Received From date should be less than Received To date', '');
                return;
            }   
        }

        this.BindSearchFileds();
        this._mApp.ShowLoader();
        this.searchFields.IsForExcel = true;
        
        this._http.post(this._appUrl.OilAnalysisExportExcel, this.searchFields)
            .subscribe(
                res => {
                    this._mApp.HideLoader();
                    const responseData = res.json();
                    
                    // Handle response: Result property wraps the full URL
                    let fullUrl = null;
                    if (responseData && responseData.Result) {
                        fullUrl = responseData.Result;
                    } else if (typeof responseData === 'string') {
                        fullUrl = responseData;
                    }
                    
                    if (fullUrl && typeof fullUrl === 'string' && fullUrl.length > 0) {
                        // Use simple window.open pattern (like DownloadNablExcel)
                        window.open(fullUrl, '_blank');
                        this._toastrService.success('Excel report exported successfully', '');
                    } else {
                        console.error('Invalid URL response:', fullUrl);
                        this._toastrService.error('Invalid response from server', '');
                    }
                    
                    this.searchFields.IsForExcel = false;
                },
                error => {
                    this._mApp.HideLoader();
                    this.searchFields.IsForExcel = false;
                    console.error('Error exporting Excel:', error);
                    this._toastrService.error('Error exporting Excel report', '');
                }
            );
    }


     GenerateReportTemp() {
     const customerVal = this.searchForm.controls['CustomerId'].value;
     const jobCardVal = this.searchForm.controls['JobCardNumber'].value;

     if ((!customerVal || customerVal.length === 0) &&
         (!jobCardVal || jobCardVal.length === 0)) {

         this._toastrService.error('Please select Customer and Job Card', '');
         return;
     }

     if (!customerVal || customerVal.length === 0) {
         this._toastrService.error('Please select Customer', '');
         return;
     }

     if (!jobCardVal || jobCardVal.length === 0) {
         this._toastrService.error('Please select Job Card', '');
         return;
     }

        this.BindSearchFileds();
        this._mApp.ShowLoader();
        this.searchFields.IsForExcel = true;
        this._http.post(this._appUrl.DownLoadConsolidatedReport, this.searchFields)
            .subscribe(
                res => {
                    this.searchFields.IsForExcel = false;
                    var data = res.json().Result;
                    window.open(res.json().Result, '_blank');
                    this._mApp.HideLoader();
                },
                error => {
                    this._mApp.HideLoader();
                    this._toastrService.error(error.json().Result, '');
                }
            );
    }

}
